import * as React from "react";
import { styled, alpha } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import logo from "../images/Citizens_R_Horz_RGB.png";
import LogoutIcon from "@mui/icons-material/Logout";
import Avatar from "@mui/material/Avatar";
import { deepOrange } from "@mui/material/colors";
import dp from "../images/1.jpg";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
}));

const Navbar = () => {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="static"
        className="rounded-lg bg-white text-black flex-1"
      >
        <Toolbar>
          <Box sx={{ display: { xs: "none", md: "flex" } }}>
            <img
              src={logo}
              alt="citizens_bank_logo"
              className="h-[28px] w-[174px]"
            />
          </Box>
          <Search className="bg-[#F0F0E6] text-black max-w-full flex-1">
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
              placeholder="How can we help you?"
              inputProps={{ "aria-label": "search" }}
            />
          </Search>
          <Divider orientation="vertical" variant="middle" flexItem />
          <LogoutIcon className="ml-2" />
          <Avatar
            className="ml-2"
            sx={{ bgcolor: deepOrange[500], width: 35, height: 35 }}
            src={dp}
          ></Avatar>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default Navbar;
